import React from "react";
import clsx from "clsx";
import UserSettings from "features/User/Settings";
import { USER_DOCS_URL, isTabletSize } from "utils";
import { useTranslation } from "react-i18next";
import { userStore } from "store/UserStore";
import { globalStore } from "store/GlobalStore";
import { observer } from "mobx-react-lite";
import ConfirmModal from "components/ConfirmModal";
import { useAuth0 } from "@auth0/auth0-react";
import useSignout from "hooks/useSignout";
import { IconBook, IconLogout, IconSettings } from "@tabler/icons-react";

const SidebarFooter = (props: { isAsset: boolean }) => {
  const { t } = useTranslation();
  const { user } = useAuth0();
  const { userProfile } = userStore;
  const signOut = useSignout();
  const [openConfirm, setOpenConfirm] = React.useState(false);

  function handleOpenSettings() {
    userStore.setOpenSettings(true);
    if (isTabletSize()) {
      globalStore.setSidebarOpened(false);
    }
  }

  function showUserIcon() {
    return (
      <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-gray-500">
        <span className="font-medium leading-none text-white text-xs">
          {`${userProfile?.first_name
            ?.toUpperCase()
            .charAt(0)}${userProfile?.last_name?.toUpperCase().charAt(0)}`}
        </span>
      </span>
    );
  }

  return (
    <>
      <div
        className={clsx(
          "flex-1 z-10 lg:inset-y-0 lg:flex max-h-[56px] text-sm bottom-0 !top-auto bg-white",
          "lg:w-[350px] lg:flex-col lg:border-r border-gray-300 border-t"
        )}
      >
        <div className="flex justify-between py-3 px-4 items-center">
          <div className="flex items-center">
            {showUserIcon()}
            <span className="pl-2">
              {userProfile ? userProfile.first_name : user?.nickname}
            </span>
          </div>
          <div className="flex text-gray-700">
            {!props.isAsset && (
              <IconBook
                width={24}
                className="mr-1 hover:text-gray-500 cursor-pointer"
                onClick={() => window.open(USER_DOCS_URL, "_blank")}
              />
            )}
            <IconSettings
              width={24}
              className="mr-1 hover:text-gray-500 cursor-pointer"
              onClick={handleOpenSettings}
            />
            <IconLogout
              width={24}
              className="hover:text-gray-500 cursor-pointer"
              onClick={() => setOpenConfirm(true)}
            />
          </div>
        </div>
      </div>
      <ConfirmModal
        onConfirm={signOut}
        open={openConfirm}
        close={() => setOpenConfirm(false)}
        confirmButtonTitle={t("commons.yes")}
        cancelTitle={t("commons.cancel")}
        title={t("commons.logout")}
        descriptionMesage={t("commons.areYouSure")}
      />
      <UserSettings />
    </>
  );
};

export default observer(SidebarFooter);
